/**
 * OS MOTIVOS QUE RETÊM UMA OS — a lista, e só a lista.
 *
 * Fica num arquivo sozinho, sem nenhum import, pelo mesmo motivo de
 * server/tipos-equipamento.ts: `src/config.ts` importa daqui para montar o
 * seletor da tela, e o front NÃO pode arrastar junto o driver do banco (é o que
 * aconteceria se a lista morasse em server/pendencias-os.ts, que importa `sql`).
 *
 * Uma lista só, dos dois lados: o servidor recusa o que não estiver aqui, e a
 * tela não oferece motivo que o servidor rejeita.
 */
export const TIPOS_PENDENCIA = ["Pagamento", "Documentação", "Comercial", "Outro"] as const;

export type TipoPendencia = (typeof TIPOS_PENDENCIA)[number];
